import {alias, createModelSchema} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";

export class SkySprintConfig extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._reward = null;

        this._dailyest = 0;
        this._winTokens = 0;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get dailyest() {
        return this._dailyest;
    }

    set dailyest(value) {
        this._dailyest = value;
    }

    get winTokens() {
        return this._winTokens;
    }

    set winTokens(value) {
        this._winTokens = value;
    }


    valid() {

        if (!Number.isInteger(this.dailyest) || this.dailyest <= 0) {
            return false;
        }

        if (!Number.isInteger(this.winTokens) || this.winTokens <= 0) {
            return false;
        }

        if (!this.reward || this.reward.empty() || !this.reward.valid()) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SkySprintConfig());
        } else if (target instanceof SkySprintConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SkySprintConfig, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _reward: alias("reward", RewardBunch.schema()),

    _dailyest: alias("dailyest", Schema.primitive()),
    _winTokens: alias("win_tokens", Schema.primitive())
});